import React from 'react';
import TabPanel, { Item as TabPanelItem } from 'devextreme-react/tab-panel';

import {
 CardActivities,
  CardNotes,
  CardTasks,
  WorkTaskTable,
} from '../..';

export const ContactCards = ({
  isLoading,
   relationOid,
    notes,
    notesCount,
    remarks,
    remarksCount,
}) => {
  return (
    <div className='dx-card details-card'>
      <TabPanel showNavButtons deferRendering={false}>
        <TabPanelItem title='Contracten'>
          <CardTasks
            isLoading={isLoading}
            relationOid={relationOid}
          />
        </TabPanelItem>
        <TabPanelItem title='Documenten'>
            <CardActivities relationOid={relationOid} />
        </TabPanelItem>
        <TabPanelItem title='Offerte aanvraag' badge={notesCount}>
            <CardNotes items={notes} />
        </TabPanelItem>
        <TabPanelItem title='Opmerkingen' badge={remarksCount}>
            <CardNotes items={remarks} />
        </TabPanelItem>
        <TabPanelItem title='Opdrachten' badge={remarksCount}>
        <WorkTaskTable isLoading={false} relationOid={relationOid} backTo='crmDetails' />
        </TabPanelItem>
      </TabPanel>
    </div>
  );
};
